<ng-container *ngIf="item">
  <div class="chips" *ngIf="item.availabilityView.status === 'AVAILABLE'">
    <div class="chip" *ngIf="item.availabilityView.nextAvailableDate">
      <span class="ellipse">
        <ng-container i18n="@@OrderItem.Available">Available</ng-container>
      </span>
      <span class="no-ellipse">
        {{ item.availability?.nextAvailableDate | date : 'd MMM' }}
      </span>
    </div>
  </div>

  <div class="chips" *ngIf="item.availabilityView.status === 'UNAVAILABLE'">
    <div
      class="chip"
      *ngFor="let region of item.availabilityView.availableRegions; trackBy: 'id' | trackBy"
      [matTooltip]="language.availabilityNote + region.name + '.'"
      matTooltipPosition="below"
      matTooltipClass="accent p-4"
    >
      {{ region.label }}
    </div>
  </div>

  <div class="chips" *ngIf="item.availabilityView.status === 'OUT_OF_STOCK'">
    <div class="chip" *ngIf="item.availability?.nextAvailableQuantity as quantity">
      <span class="ellipse">
        <ng-container i18n="@@OrderItem.AvailableStock.Short">AVAIL STOCK.</ng-container>
      </span>
      <span class="no-ellipse">{{ quantity }}</span>
    </div>
  </div>
</ng-container>
